import React from 'react'
import styled from 'styled-components'
import { ReactComponent as Check } from "../../assets/icons/benefitCheck.svg"
import { ReactComponent as NoCheck } from "../../assets/icons/benefitNoCheck.svg"
const BenefitItem = ({ benefit, text }) => {
    return (
        <Container benefit={benefit}>
            {benefit ? <Check /> : <NoCheck />}
            <p>{text}</p>
        </Container>
    )
}

export default BenefitItem
const Container = styled.div`
display:flex;
align-items:center;
gap:20px;
padding:20px;
border-radius:10px;
width:100%;
svg{
min-height:28px;
min-width:28px;
}
${({ benefit }) => benefit ? `
background:rgba(139, 215, 154, 0.1);
border:1px solid rgba(237, 235, 234, 1);
p{
color:rgba(19, 74, 60, 1);
font-weight: 500;
font-size: 18px;
line-height: 24px;
letter-spacing: 0%;
}
`: `
background:rgba(237, 112, 102, 0.1);
border:1px solid rgba(237, 235, 234, 1);
p{
color:rgba(159, 67, 60, 1);
font-weight: 400;
font-size: 18px;
line-height: 24px;
letter-spacing: 0%;
}
`}
`